export default class Router {
  constructor(options) {
    this.routes = options.routes;
    this.defaultRoute = options.defaultRoute || 'index';
    this.context = options.context;
    this.onRouteChange = options.onRouteChange || function () {};
    this.currentRoute = null;
    this.currentPage = null;
    this.navigationToken = 0;

    this.handleHashChange = this.handleHashChange.bind(this);
  }

  start() {
    window.addEventListener('hashchange', this.handleHashChange);
    this.handleHashChange();
  }

  stop() {
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  navigate(routeId) {
    const target = routeId || this.defaultRoute;
    const hash = `#/${target}`;
    if (window.location.hash === hash) {
      this.handleHashChange();
      return;
    }
    window.location.hash = hash;
  }

  resolveRouteFromHash(hash) {
    const cleanHash = (hash || '').replace(/^#\/?/, '').trim();
    if (!cleanHash) {
      return this.defaultRoute;
    }
    const route = cleanHash.split('/')[0];
    if (!this.routes[route]) {
      return this.defaultRoute;
    }
    return route;
  }

  async handleHashChange() {
    const routeId = this.resolveRouteFromHash(window.location.hash);
    const nextPage = this.routes[routeId];
    if (!nextPage) {
      return;
    }

    const token = ++this.navigationToken;

    if (this.currentPage && this.currentPage !== nextPage) {
      await this.currentPage.unmount(this.context);
      if (token !== this.navigationToken) {
        return;
      }
    }

    if (this.currentPage !== nextPage || this.currentRoute !== routeId) {
      await nextPage.mount(this.context);
      if (token !== this.navigationToken) {
        return;
      }
    }

    this.currentPage = nextPage;
    this.currentRoute = routeId;
    this.onRouteChange(routeId);
  }
}
